// extracted by css-extract-rspack-plugin
export default {"iframeContainer":"_1cHP7LJzCu2UFWpbxuGoGq","looker":"_1R-Erc0Wr7E53nYZPZcXu5","tabsContainer":"dU5MNkQaZXACYvUYGvjsn"};